import type { IOperationResponse } from "../services/api";
import type { IWidgetSession } from "../shared/session/interfaces/session";
import { countryFromCurrency } from "../hooks/useExchangeRate";

/**
 * Destination country for the home FX chip: last send only picks the country.
 * Recipient address > claim corridor > currency map.
 */
export const resolveDestinationCountry = (
  latest: IOperationResponse | undefined,
  session: IWidgetSession | null
): string | undefined => {
  const fromRecipient = latest?.recipient?.address?.countryISO2?.trim();
  if (fromRecipient) return fromRecipient.toUpperCase();

  const corridor =
    session?.config?.defaultCorridor || session?.config?.corridors?.[0];
  const fromClaim =
    corridor?.destinationCountryCode?.trim() ||
    session?.config?.destinationCountry?.trim();
  if (fromClaim) return fromClaim.toUpperCase();

  return countryFromCurrency(latest?.destinationCurrency);
};
